import React, { useCallback, useState } from 'react';

import { Button } from 'react-bootstrap';
import { FaTrash } from 'react-icons/fa';
import { useToast } from '../../../../hooks/toast';
import api from '../../../../services/api';
import getResponseErrors from '../../../../utils/getResponseErrors';

import Loading from '../../../Loading';
import Modal from '../../../Modal';

type Props = {
  plaCodigo: number;
  chiCodigo: number;
  updated_at: Date;
};
const ChipDelete: React.FC<Props> = ({ updated_at, plaCodigo, chiCodigo }) => {
  const { addToast } = useToast();
  const [loading, setLoading] = useState(false);
  const [showModalConfirmacao, setshowModalConfirmacao] = useState(false);

  const handleDeleteChip = useCallback(async () => {
    setLoading(true);
    setshowModalConfirmacao(false);
    try {
      await api.delete(
        `planos/chip/${plaCodigo}?ChiCodigo=${chiCodigo}&updated_at=${updated_at}`,
      );
      window.location.replace(`/cartaosaudedetalhe/${plaCodigo}`);
    } catch (error) {
      const mensagemErro = getResponseErrors(error);
      addToast({
        title: 'Não foi possível excluir a linha',
        type: 'error',
        description: mensagemErro,
      });
    } finally {
      setLoading(false);
    }
  }, [plaCodigo, chiCodigo, updated_at, addToast]);

  return (
    <>
      {loading && <Loading />}

      {showModalConfirmacao ? (
        <Modal
          show={showModalConfirmacao}
          titulo="Remover Linha"
          handleFecharModal={() => setshowModalConfirmacao(false)}
        >
          <div className="my-4">
            <h5>Essa operação não poderá ser desfeita.</h5>

            <Button
              type="submit"
              className="mt-2"
              variant="danger"
              onClick={() => handleDeleteChip()}
              disabled={loading}
            >
              Prosseguir com a exclusão
            </Button>
            <Button
              type="button"
              className="mt-2 ml-3"
              variant="outline-secondary"
              onClick={() => setshowModalConfirmacao(false)}
              disabled={loading}
            >
              Voltar
            </Button>
          </div>
        </Modal>
      ) : (
        <Button
          data-id={chiCodigo}
          type="button"
          variant="outline-danger"
          size="sm"
          style={{ padding: '1px 8px' }}
          onClick={() => setshowModalConfirmacao(true)}
        >
          <FaTrash size={14} />
        </Button>
      )}
    </>
  );
};

export default ChipDelete;
